// src/state/settings/licenseSettings/initialStates.ts
var LICENSE_SETTINGS_INITIAL_STATE = {
  id: 0,
  createdAt: null,
  updatedAt: null,
  deletedAt: null,
  overrideRestaurantMode: null,
  language: "en",
  fontSize: "normal" /* NORMAL */,
  revenueCenterId: null,
  displayMode: "dark" /* DARK */,
  registerAutoLock: null,
  defaultServiceAreaId: null,
  linkedMsr: "",
  linkedTerminal: "",
  allowCashPayments: true,
  allowCardPayments: true,
  allowGiftCardPayments: true,
  allowMobilePayments: true,
  defaultPaymentMethod: "credit",
  drawerHardwareType: "single",
  autoPrintChit: false,
  suppressSeating: false,
  suppressAssignOrderTag: false,
  suppressAllowForTableButton: false,
  suppressShowSeatOneDescription: false,
  suppressSuggestiveOrdering: false,
  printOrderNumberOnSend: false,
  useCFD: false,
  overrideDefaultMenuTypeId: null,
  splittingFee: null,
  qsrSendAndPayActionButtonsOverride: null,
  sendOrderToKitchenOverride: null,
  nickname: "",
  stationNumber: 0,
  defaultCheckPrinterId: null,
  printReceiptOnPayment: true,
  eGiftCardTerminalId: "0001",
  defaultServiceAreaOption: null
};

export { LICENSE_SETTINGS_INITIAL_STATE };
